import type { WorkOrder } from '@xbcb/api-gateway-client';
import { isFbaScotForwarder } from '@xbcb/party-utils';
import { isEuCustomsEntry } from '@xbcb/work-order-utils/dist/isEuCustomsEntry';
import { isEuCustomsDeclaration } from '@xbcb/work-order-utils/dist/isEuCustomsDeclaration';

export const isBrexitWorkOrder = (workOrder?: WorkOrder): boolean => {
  const isBrexitForwarder = workOrder?.group?.forwarders?.some((forwarder) =>
    isFbaScotForwarder(forwarder.forwarder),
  );
  const isEuWorkOrder =
    isEuCustomsEntry(workOrder?.id) || isEuCustomsDeclaration(workOrder);
  return Boolean(isEuWorkOrder && isBrexitForwarder);
};
